import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 10, viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.0001 7.77999L1.2201 4.99999L0.273438 5.93999L4.0001 9.66665L12.0001 1.66665L11.0601 0.726654L4.0001 7.77999Z", fill: "#1E1A26" }));
const ForwardRef = forwardRef(SvgCheckmark);
export default ForwardRef;
